import React from 'react'
import ArticleIcon from '@mui/icons-material/Article'
import StarsIcon from '@mui/icons-material/Stars'
import TuneIcon from '@mui/icons-material/Tune'
import LogoutIcon from '@mui/icons-material/Logout'
import { Link }  from 'react-router-dom'
import { useRouter } from '../../../hooks/useRouter';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences'
import styles from '../../../styles/DashboardSidebar.module.css'

const SideBarItems = [
  // {
  //   name: 'Dashboard',
  //   link: '/school-dashboard',
  //   icon: <StarsIcon />,
  // },
  {
    name: 'Application List',
    link: '/school-dashboard/application-list',
    icon: <ArticleIcon />,
  },
  {
    name: 'Admission Settings',
    link: '/school-dashboard/configuration',
    icon: <RoomPreferencesIcon />,
  },
  {
    name: 'Change Password',
    link: '/school-dashboard/settings',
    icon: <TuneIcon />,
  },
  {
    name: 'Logout',
    link: '/school-dashboard/logout',
    icon: <LogoutIcon />,
  },
]

const DashboardSidebar = () => {
  //get the current url
  const router = useRouter()
  const currentUrl = router.pathname
  return (
    <div className='container'>
     
        <div className=' mt-5 pt-5'>
          <div className={styles.sidebar}>
            {SideBarItems.map((item, index) => (
              <div key={index}>
                <Link
                  to={item.link}
                  className={
                    currentUrl === item.link
                      ? styles.sidebarItemActive
                      : styles.sidebarItem
                  }
                >
                  <div className={styles.sidebarItemIcon}>{item.icon}</div>
                  <div className={styles.sidebarItemName}>{item.name}</div>
                </Link>
              </div>
            ))}
          </div>
        </div>
     
    </div>
  )
}

export default DashboardSidebar
